import { render } from "./file_manager.vue?vue&type=template&id=e6e3d9c6"
import script from "./file_manager.vue?vue&type=script&lang=js"
export * from "./file_manager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__